import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createOnboardingActions } from './onboarding.actions'
import { onboardingInitialState } from './onboarding.slice'
import type { OnboardingStore } from './onboarding.type'

export const useOnboardingStore = create<OnboardingStore>()(
  devtools(
    subscribeWithSelector(
      immer((set) => ({
        ...onboardingInitialState,
        ...createOnboardingActions(set),
      }))
    ),
    {
      name: StoreDevtoolsName.Onboarding,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
